<template>
    <div class="box">
        <div class="box-left">
            <div class="box-content">
                <el-row style="height:100%;">
                    <el-col :span="4.8" class="item span5" @click.native="showProState()">
                        <img src="../../assets/image/box-l.png" class="img-l" />
                        <img src="../../assets/image/box-r.png" class="img-r" />
                        <div class="item-div">
                            <p>项目总数</p><p>{{num.all}}</p>
                        </div>
                    </el-col>
                    <el-col :span="4.8" class="item span5" @click.native="showProState(2)">
                        <img src="../../assets/image/box-l.png" class="img-l" />
                        <img src="../../assets/image/box-r.png" class="img-r" />
                        <div class="item-div">
                            <p>在建项目</p><p>{{num.zj}}</p>
                        </div>
                    </el-col>
                    <el-col :span="4.8" class="item span5" @click.native="showProState(3)">
                        <img src="../../assets/image/box-l.png" class="img-l" />
                        <img src="../../assets/image/box-r.png" class="img-r" />
                        <div class="item-div">
                            <p>竣工项目</p><p>{{num.jg}}</p>
                        </div>
                    </el-col>
                    <el-col :span="4.8" class="item span5" @click.native="showProState(4)">
                        <img src="../../assets/image/box-l.png" class="img-l" />
                        <img src="../../assets/image/box-r.png" class="img-r" />
                        <div class="item-div">
                            <p>停工项目</p><p>{{num.tg}}</p>
                        </div>
                    </el-col>
                    <el-col :span="4.8" class="item span5" @click.native="showProState(1)">
                        <img src="../../assets/image/box-l.png" class="img-l" />
                        <img src="../../assets/image/box-r.png" class="img-r" />
                        <div class="item-div">
                            <p>拟建项目</p><p>{{num.lj}}</p>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="box-map">
                <baidu-map
                    :center="center"
                    id="xjMap"
                    :zoom="zoom"
                    @ready="handler"
                    style="height:100%;width:100%;"
                    @click="getClickInfo"
                    :scroll-wheel-zoom="true"
                >
                    <bm-marker v-for="item in points" @click="clickHandler(item)" :key="item.id" :position="item.position"  :icon="{url: require('../../assets/image/point.png'), size: {width: 50, height: 50}}">
                    </bm-marker>
                </baidu-map>
            </div>
        </div>
        <div class="box-right">
            <div class="grid-tab">
                <div class="grid-tab-head">
                    <div>
                        <span class="title color3" style="font-weight: bold;">项目进度统计</span>
                        <span class="box-green"></span>
                        <span v-if="opt.projectStatus=='1'" style="left: 35px;position: relative;color: #fff;">（拟建项目）</span>
                        <span v-else-if="opt.projectStatus=='2'" style="left: 35px;position: relative;color: #fff;">（在建项目）</span>
                        <span v-else-if="opt.projectStatus=='3'" style="left: 35px;position: relative;color: #fff;">（竣工项目）</span>
                        <span v-else-if="opt.projectStatus=='4'" style="left: 35px;position: relative;color: #fff;">（停工项目）</span>
                        <span v-else style="left: 35px;position: relative;color: #fff;">（全部项目）</span>
                    </div>
                </div>
                <div class="hr"></div>
                <div class="progress-item" v-for="item in progressList" :key="item.id">
                    <div style="width:200px;height:100%;display:flex;align-items: center;overflow: hidden;" :title="item.name">
                        <span class="nowrap">{{item.name}}</span>
                    </div>
                    <div style="width:calc( 50% - 140px );height:100%;">
                        <p style="width:100%;display:flex;padding:5px 10px;">
                            <span style="display: inline-block;margin:0 10px;text-align: left;color:#36C635;">投资进度</span>
                        </p>
                        <p style="width:100%;display:flex;padding:5px 10px;">
                            <el-progress :text-inside="true" :stroke-width="24" :percentage="item.cumulativeComplete" status="success" style="flex:1;"></el-progress>
                        </p>
                        <p style="width:100%;display:flex;padding:5px 10px;">
                            <span style="bottom: 2px;font-size: 14px;left: 100px;flex:1;">合同额：{{item.price}}万</span>
                            <span style="bottom: 2px;font-size: 14px;left: 100px;flex:1;">目前进度{{item.cumulativeComplete}}%</span>
                            <span style="bottom: 2px;font-size: 14px;left: 100px;flex:1;">已投金额：{{item.cumulativeComplete}}</span>
                        </p>
                    </div>
                    <div style="width:calc( 50% - 140px );height:100%;padding:0 10px;">
                        <p style="width:100%;display:flex;padding:5px 10px;">
                            项目地址
                        </p>
                        <p style="width:100%;display:flex;padding:5px 10px;overflow: hidden;" :title="item.address">
                            <span class="nowrap">{{item.address}}</span>
                        </p>
                    </div>
                    <div style="width:80px;height:100%;align-items: center;display:flex;">
                        <span style="font-size:18px;cursor: pointer;" @click="clear(item)">更多</span>
                    </div>
                    <!-- <p style="width:100%;display:flex;padding: 10px;">
                        <span class="nowrap" :title="item.name" style="display: inline-block;margin:0 10px;text-align: left;flex:1;color:#4D7BF4;">{{item.name}}</span>
                        <span style="display: inline-block;margin:0 10px;width: 100px;text-align: left;">工期{{item.allDay}}天</span>
                        <span style="display: inline-block;margin:0 10px;width: 80px;text-align: left;">进度{{item.progress}}%</span>
                        <span style="display: inline-block;margin:0 10px;width: 120px;text-align: left;">剩余工期{{item.otherDay}}天</span>
                    </p>
                    <p style="width:100%;display:flex;padding:5px 10px;">
                        <span style="display: inline-block;margin:0 10px;text-align: left;color:#36C635;">投资进度</span>
                        <el-progress :text-inside="true" :stroke-width="24" :percentage="item.cumulativeComplete" status="success" style="flex:1;"></el-progress>
                        <span style="position: absolute;bottom: 2px;font-size: 12px;left: 100px;">累计工程完成量{{item.cumulativeComplete}}%</span>
                    </p> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
export default {
    data(){
        return{
            center: {
                lng: 117.283334,
                lat: 31.866339
            },
            map: {},
            zoom: 12,
            points:[],
            curIndex:undefined,
            projects:[],
            name:'',
            areaId:'',
            opt:{
                name:'',
                entId:'',
                joinType:'3',
                projectStatus:'2'
            },
            groupId:'',
            num:{
                all:0,
                zj:0,
                jg:0,
                tg:0,
            },
            progressList:[],
        }
    },
    mounted(){
        this.groupId = this.$store.state.groupId
        if ('' == this.groupId || undefined == this.groupId) {
            this.groupId = util.session.get('groupId')
        }
        //this.getData()
        util.session.remove('backPage')
        this.getAllPro()
        this.getAllNum()
    },
    methods:{
        //监听选择
        doFilte(){
            this.getData()
        },
        //地图展示
        handler({ BMap, map }) {
            this.map = map
            this.getData()
            // var cityName = '安徽省';
            // map.centerAndZoom(cityName, 11);                     // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
            map.enableScrollWheelZoom();
            // var bdary = new BMap.Boundary();
        },
        showMarker(list){
            var points = [];
            for (var i = 0; i < list.length; i++) {
                if(list[i].gpsPoint&&''!=list[i].gpsPoint){
                    var obj = list[i]
                    var position = list[i].gpsPoint.split(',')
                    obj.position = {lng: position[0], lat: position[1]}
                    obj.typeName = list[i].projectType=='1'?'房建':'市政'
                    
                    if(list[i].allDay){
                        var readDay = parseInt(list[i].allDay) - parseInt(list[i].otherDay) 
                        obj.progress = ((readDay / list[i].allDay) * 100).toFixed(2)
                    }else{
                        obj.progress = 0
                    }
                    points.push(obj)
                }
            }
            this.center = points.length>0?points[0].position:this.center
            this.points = points
        },
        //地图点击方法
        getClickInfo(e) {
            if(!this.curIndex){
                var allOverlay = this.map.getOverlays();
                for(var i=0;i<allOverlay.length;i++){
                    if(allOverlay[i].toString()=="[object Overlay]"){
                        this.map.removeOverlay(allOverlay[i]);
                    }
                }
            }
            this.infoWindowClose()
        },
        //点击方法
        clickHandler(e){
            this.curIndex = e
            this.showMapMarker(e)
        },
        //关闭
        infoWindowClose(){
            this.curIndex = undefined
        },
        //查看
        clear(row){
            util.session.set('proId', row.id)
            util.session.set('backPage', '6')
            var that = this
            setTimeout(function() {
                that.$router.push({ path: '/entProInfo' })
            }, 0)
        },

        //获取项目数量
        getAllNum() {
            var that = this
            myHttp.getListEnterpriseAndJoinType({
                entId:this.groupId,
                joinType:'3'
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data
                    that.num.all = data.all
                    that.num.zj = data.zj.zjxm
                    that.num.tg = data.tg.tgxm
                    that.num.jg = data.jg.jgxm
                    that.num.lj = data.lj.ljxm
                }
            })
        },
        
        //获取数据
        getData(){
            var that = this
            this.opt.entId = this.groupId
            myHttp.getProjectListByEntIdAndJoinType(this.opt).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    that.projects = list
                    that.showMarker(list)
                }
            })
        },
        //获取所有的项目
        getAllPro(){
            var that = this
            var opt = {
                entId : this.groupId,
                pageNum:1,
                pageSize:10000,
                joinType:3,
                projectStatus:this.opt.projectStatus
            }
            myHttp.getProjectPageListByEntIdAndJoinType(opt).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.pageInfo.list || []
                    for(var i=0;i<list.length;i++){
                        if(list[i].allDay==0){
                            list[i].progress = 0
                        }else{
                            list[i].progress = ((parseInt(list[i].allDay)-parseInt(list[i].otherDay))/parseInt(list[i].allDay)*100).toFixed(0)
                        }
                        list[i].price = list[i].price?list[i].price:0
                        list[i].progress = parseFloat(list[i].progress)
                        list[i].cumulativeComplete = list[i].cumulativeComplete?parseFloat(list[i].cumulativeComplete):0
                    }
                    //console.log(list)
                    that.progressList = list
                }
            })
        },

        /**
         * 根据状态获取项目列表
         */
        showProState(index){
            if(index){
                this.opt.projectStatus = index
            }else{
                this.opt.projectStatus = ''
            }
            this.getData()
            this.getAllPro()
        },

        baiduMap() {
            var that = this
            this.map = new BMap.Map("xjMap");
            // var cityName = '安徽省';
            // this.map.centerAndZoom(cityName, 8);                     // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
            this.map.enableScrollWheelZoom();
            // var bdary = new BMap.Boundary();
            
        },

        //展示地图数据
        showMapMarker(obj){
            var _selt = this
            // 复杂的自定义覆盖物
            function ComplexCustomOverlay(point,obj){
                this._point = point;
                this._option = obj
            }
            ComplexCustomOverlay.prototype = new BMap.Overlay();
            ComplexCustomOverlay.prototype.initialize = function(map){
                this._map = map;
                var option = this._option;
                var div = this._div = document.createElement("div");
                div.style.position = "absolute";
                div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
                div.style.height = "300px";
                div.style.width = "220px";
                div.style.background = "rgba(19, 46, 140, 0.8)";
                div.style.borderRadius = "5px";
                div.style.padding = "10px";
                div.style.cursor = 'pointer'
                var that = this;

                //图片
                var imgDiv = document.createElement("img");
                imgDiv.style.position = "relative";
                imgDiv.style.width = "200px";
                imgDiv.style.height = "150px";
                imgDiv.style.marginBottom = "20px";
                var imgs = option.photoPath.split(',')
                var img = ''
                for(var i=0;i<imgs.length;i++){
                    if(imgs[i]!=''){
                        img = base.httpCtx+imgs[i]
                    }
                }
                if(img==''){
                    imgDiv.src = require('../../assets/image/zanwutupian.png')
                }else{
                    imgDiv.src = img
                }
                div.appendChild(imgDiv);

                //项目名称
                var nameText = document.createElement("p");
                nameText.style.position = "relative";
                nameText.style.width = "100%";
                nameText.style.height = "30px";
                nameText.style.fontSize = "14px";
                nameText.style.color = "rgba(255, 255, 255, 1)";
                nameText.style.whiteSpace = "nowrap";
                nameText.style.textOverflow = "ellipsis";
                nameText.style.overflow = "hidden";
                nameText.innerHTML = option.name||'';
                nameText.title = option.name||'';
                div.appendChild(nameText);

                //项目位置
                var addrText = document.createElement("p");
                addrText.style.position = "relative";
                addrText.style.width = "100%";
                addrText.style.height = "30px";
                addrText.style.fontSize = "12px";
                addrText.style.color = "rgba(255, 255, 255, 1)";
                addrText.style.whiteSpace = "nowrap";
                addrText.style.textOverflow = "ellipsis";
                addrText.style.overflow = "hidden";
                addrText.title = option.address||'';
                addrText.innerHTML = '项目位置：'+option.address;
                div.appendChild(addrText);

                //投资进度
                var progressText = document.createElement("p");
                progressText.style.position = "relative";
                progressText.style.width = "100%";
                progressText.style.height = "30px";
                progressText.style.fontSize = "12px";
                progressText.style.color = "rgba(255, 255, 255, 1)";
                progressText.innerHTML = '投资进度：'+(option.cumulativeComplete||0)+'%'+', 金额：'+(option.price||0)+'万';
                div.appendChild(progressText);

                //工期
                var dateText = document.createElement("p");
                dateText.style.position = "relative";
                dateText.style.width = "100%";
                dateText.style.height = "30px";
                dateText.style.fontSize = "12px";
                dateText.style.color = "rgba(255, 255, 255, 1)";
                dateText.innerHTML = '工期：'+option.allDay+'天, 剩余：'+option.otherDay+'天（'+option.progress+'%）';
                div.appendChild(dateText);

                div.onclick = function(){
                    util.session.set('proId', option.id)
                    util.session.set('backPage', '6')
                    //var that = this
                    setTimeout(function() {
                        _selt.$router.push({ path: '/entProInfo' })
                    }, 0)
                }

                map.getPanes().labelPane.appendChild(div);
                
                return div;
            }
            ComplexCustomOverlay.prototype.draw = function(){
                var map = this._map;
                var pixel = map.pointToOverlayPixel(this._point);
                this._div.style.left = (pixel.x + 20) + 'px' ;
                this._div.style.top  = pixel.y  + 'px' ;
            }
            var allOverlay = this.map.getOverlays();
            for(var i=0;i<allOverlay.length;i++){
                if(allOverlay[i].toString()=="[object Overlay]"){
                    this.map.removeOverlay(allOverlay[i]);
                }
            }
            var gpsLi = obj.gpsPoint.split(",");
            var myCompOverlay = new ComplexCustomOverlay(new BMap.Point(gpsLi[0], gpsLi[1]),obj);
            this.map.addOverlay(myCompOverlay);
        },
    }
}
</script>
<style scoped>
    *{
        box-sizing: border-box;
    }
    .box{
        width:100%;
        position: relative;
        height: 100%;
        display: flex;
        background: #010d27;
    }
    .box-left{
        width: 40%;
        height: 100%;
        position: relative;
    }
    .box-content{
        width:100%;
        height: 100px;
        padding-top: 10px;
    }
    .box-content .item{
        position: relative;
        padding:20px;
        height:100%;
    }
    .box-content .item-div{
        width:100%;
        height:100%;
        background:#2058D9;
        display:flex;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
        z-index: 100;
    }
    .box-content .item-div p{
        width:100%;
        color: #fff;
        font-size: 18px;
        margin: 0;
    }
    .box-content .img-l{
        width:84px;
        height:61px;
        position: absolute;
        top: 5px;
        left: 5px;
    }
    .box-content .img-r{
        width:84px;
        height:61px;
        position: absolute;
        bottom: 5px;
        right: 5px;
    }
    .box-map{
        width: 100%;
        height: calc( 100% - 100px );
        position: relative;
        padding: 10px;
        box-sizing: border-box;
    }

    .box-right{
        width: 60%;
        height: 100%;
        position: relative;
        padding: 10px;
    }
    .grid-tab{
        width: 100%;
        height: 100%;
        position: relative;
        box-sizing: border-box;
        overflow: auto;
    }
    .bg-color1{
        background: rgba(255,255,255,.04);
    }
    .bg-color2{
        background: rgba(255,255,255,.27);
    }
    .grid-tab-head{
        width:100%;
        height:50px;
        display:flex;
        justify-content:space-between;
        align-items: center;
        padding-right: 10px;
    }
    .grid-tab-head .title{
        font-size:18px;
        /* font-weight: bold; */
    }
    .grid-tab-head .more{
        color:#4ECBFF;
        cursor: pointer;
    }
    .grid-tab .hr,.grid-box .hr{
        width:100%;
        height:2px;
        position: relative;
        background: linear-gradient(to right, #2E08F2, #080019);
    }
    .box-green{
        width:20px;
        height:20px;
        background:#36C635;
        display: inline-block;
        position: relative;
        top: 4px;
        left: 20px;
        border-radius: 2px;
        animation: border_shrink 1s ease-out infinite;
    }
    @keyframes border_shrink {
        0% {
            box-shadow: 0 0px 0px 0px rgba(54, 198, 53, 0.14), 0 0px 0px 1px rgb(54, 198, 53,0.5);
        }
        100% {
            box-shadow: 0 0px 0px 3px rgba(54, 198, 53, 0.14), 0 0px 0px 4px rgba(54, 198, 53,0.5);
        }
    }
    .map-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .color3{
        color:#4D7BF4;
    }
    .progress-item{
        width: 100%;
        height: 90px;
        position: relative;
        font-size:16px;
        background:linear-gradient(92deg,rgba(2,25,149,1) 0%,rgba(0,3,84,1) 100%);
        color:#AECFDC;
        margin: 10px 0;
        display: flex;
        padding:0 10px;
        box-sizing: border-box;
    } 
    .grid-tab::-webkit-scrollbar,.ent-menu::-webkit-scrollbar{
        /*滚动条整体样式*/
        width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 0px;
    }
    .grid-tab::-webkit-scrollbar-thumb,.ent-menu::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        background: #fff;
    }
    .grid-tab::-webkit-scrollbar-track,.ent-menu::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        background: #fff;
    }
    .nowrap{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .span5{
        width:20%;
        cursor: pointer;
    }
</style>
<style>
    .progress-item .el-progress-bar__outer{
        background-color:#4D7BF4;
    }
    /* .selectCon .el-input{
        width: 300px;
        height: 50px;
    }
    .selectCon .el-input input{
        height: 50px;
        background: #707070;
        color: #ffffff;
        font-size: 18px;
    } */
    /* .fen-val .el-input__inner{
        background: transparent;
        border: 0;
        font-size: 16px;
        text-align: right;
        color: #fff;
    }
    .fen-sel{
        background: #001498;
        border: 0;
    }
    .fen-sel .el-select-dropdown__empty{
        color: #fff;
    }
    .fen-val.el-select .el-input{
        width: 240px;
    }
    .fen-sel .el-select-dropdown__item.hover,.fen-sel .el-select-dropdown__item:hover{
        background: transparent;
    }
    .fen-sel .el-select-dropdown__item{
        color: #AECFDC;
    } */
</style>